export default {
  independentMarketing: {
    common: {
      requestFailed: 'Arayüz isteği başarısız oldu',
      hintSelect: 'Seçme',
      hintInput: 'Girmek',
      submit: 'Göndermek',
      cancel: 'İptal etmek',
      confirm: 'TAMAM',
    },
    agreement: {
      title: 'Autel Bağımsız Bayi Kayıt Sözleşmesi',
      nextBtn: 'İleri',
      getAgreementFailed: 'Sözleşme içeriği alınamadı.',
    },
    successPage: {
      title:
        'Başvuru bilgileriniz başarıyla gönderildi ve inceleme sonuçları 15 iş günü içinde $1 e-posta adresinize gönderilecek. Daha fazla bilgi için lütfen gelen kutunuzu kontrol edin.',
      subTitle: '$1 saniye sonra ana sayfaya dönün.',
    },
    applyTitle:
      "Autel'in bağımsız bayisi olmak için başvuruyorsunuz. Lütfen aşağıdaki bilgileri doğru bir şekilde doldurun:",
    companyName: 'Şirket adı',
    companyTax: 'VAT ID',
    userCountry: 'Ülke',
    legalPerson: 'Hukuk Müşaviri',
    contactEmail: 'İletişim E-posta',
    contactEmailTips:
      'Bu e-posta adresi, inceleme sonucu e-postasıyla iletişim kuracağınız kişi olacaktır. İnceleme onaylandıktan sonra bağımsız bayi yönetim sistemi için oturum açma hesabı adı olarak da kullanılacaktır.',
    corporateIdentity: 'Hukuk müşaviri kimliği',
    uploadTips: "JPG, JPEG, PNG, PDF (20 MB'tan büyük değil)",
    businessLicense: 'İşletme lisansı',
    emailErrorTips: 'Geçerli bir e-posta girin.',
    uploadPic: 'Resimleri Yükle',
    picMaxLimit: "Maksimum resim boyutu 20 MB'tır. Lütfen tekrar seçin.",
  },
};
